const React = require("react");
const { DynamicApolloProvider } = require("./src/preview/apollo");

export const wrapRootElement = ({ element }) => {
  if (process.env.CI_ENVIRONMENT_NAME.includes("preview")) {
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DynamicApolloProvider element={element} />
      </React.Suspense>
    );
  }
  return <>{element}</>;
};
